<template>
  <v-card class="approvedOffMfa_card">
    <h2 class="approvedOffMfa_title">多要素認証設定を解除しました</h2>
    <h3 class="approvedOffMfa_caption"></h3>
    <section class="approvedOffMfa_container">
      <p>安全にご利用いただく為、多要素認証の設定をおすすめいたします。</p>
    </section>

    <footer class="approvedOffMfa_footer">
      <h5 v-ripple @click="handleReturn">ログイン画面に戻る</h5>
    </footer>
  </v-card>
</template>

<script>
export default {
  name: 'ApprovedOffMfa',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.handleConfirm();
  },
  methods: {
    handleConfirm() {
      this.$emit('confirm', this.$route.params.token);
    },
    handleReturn() {
      this.$emit('return');
    },
  },
};
</script>

<style lang="scss">
.approvedOffMfa {
  &_card {
    width: 500px;
    height: 500px;
    overflow: hidden;
    margin: 0 auto;
    margin-bottom: 110px;
    &.v-sheet.v-card:not(.v-sheet--outlined) {
      padding: 102px;
      padding-top: 30px;
      box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.06);
      background-color: #fff;
      border-radius: 10px;
    }
    .v-btn:not(.v-btn--round).v-size--large {
      height: 48px;
      border-radius: 10px;
    }

    .v-btn__content {
      font-weight: bold;
    }
    .theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
      background-color: #eeeeee !important;
    }
  }
  &_title {
    font-size: 16px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.44;
    letter-spacing: normal;
    text-align: center;
    color: #333;
  }
  &_caption {
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    color: #4b4b4b;
    text-align: left;
    margin: 20px auto;
  }

  &_container {
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    p {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: left;
      color: #666;

      display: inline;
    }
  }
  &_footer {
    margin: 0 auto;
    h5 {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      color: #0075c2;
      cursor: pointer;
      text-align: center;
      margin-top: 25px;
    }
  }
}
</style>
